import { Box, Typography } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import crossMarkIcon from "../assets/images/Vector (3).svg";
import greenTick from "../assets/images/material-symbols_check-circle-rounded.svg";
import flightIcon from "../assets/images/flight-icon-with-bg.png";

const YearlyPremiumModal = ({ open, onClose, packToShow }) => {
  const handleClose = (e) => {
    e.stopPropagation();
    setTimeout(onClose(), 3000); // Wait for animation to complete
  };

  console.log("packToShow is", packToShow);
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          key="modal-backdrop"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
            padding: "20px",
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.3 } }}
          onClick={handleClose}
          className="popup-content-container"
        >
          <motion.div
            key="modal-content"
            style={{
              backgroundColor: "#fff",
              width: "100%",
              maxWidth: "640px",
              borderRadius: "20px",
              overflow: "hidden",
            }}
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", damping: 25 }}
            onClick={(e) => e.stopPropagation()}
            className="popup-content"
          >
            <Box>
              <Box
                sx={{
                  position: "relative",
                  paddingBottom: packToShow?.introductoryOffer?.isActive
                    ? "50px !important"
                    : "10px !important",
                }}
                className={"active-box"}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px",
                  }}
                >
                  <Typography
                    variant="h6"
                    fontWeight={700}
                    gutterBottom
                    sx={{
                      color: "white",
                    }}
                  >
                    {packToShow?.name}
                  </Typography>
                  <Box
                    sx={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      border: "2px solid white",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={handleClose}
                  >
                    <img
                      src={crossMarkIcon}
                      style={{ color: "white", width: "12px", height: "12px" }}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: "10px",
                      backgroundColor: "transparent",
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        px: 1,
                        py: 0.3,
                        backgroundColor: "#F1F7FA24",
                        color: "#fff",
                        borderRadius: "20px",
                        fontWeight: 600,
                        display: "inline-block",
                        mb: 1,
                      }}
                    >
                      ${packToShow?.prices[0]?.unit_amount / 100} per month
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        px: 1,
                        py: 0.3,
                        backgroundColor: "#F1F7FA24",
                        color: "#fff",
                        borderRadius: "20px",
                        fontWeight: 600,
                        display: "inline-block",
                        mb: 1,
                      }}
                    >
                      ${packToShow?.prices[1]?.unit_amount / 100} per year
                    </Typography>
                  </Box>
                </Box>
                {packToShow?.introductoryOffer?.isActive && (
                  <Box
                    className={"time-offer-card sponsor-modal"}
                    sx={{
                      background:
                        "linear-gradient(to right, #FFF5D6, #FFD75D, #FFF5D6, #FFD75D)",
                      width: "calc(100% - 60px)",
                      position: "absolute",
                      left: 0,
                      right: 0,
                      top: "20%",
                      margin: "auto",
                      borderRadius: "10px",
                      padding: "13px",
                      marginBottom: "13px",
                      textAlign: "left",
                      height: "70px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "12px",
                          sm: "14px",
                          md: "14px",
                          lg: "14px",
                          xl: "16px",
                        },
                        fontWeight: 700,
                        color: "black",
                      }}
                    >
                      Limited Time Offer!
                    </Typography>
                    <Typography
                      variant="p"
                      sx={{
                        fontSize: {
                          xs: "12px",
                          sm: "13px",
                          md: "11px",
                          lg: "11px",
                          xl: "14px",
                        },
                      }}
                    >
                      Get {packToShow?.introductoryOffer?.freeMonths} extra
                      months of Free Content Retention!
                    </Typography>
                  </Box>
                )}
              </Box>
              <Box
                sx={{
                  padding: packToShow?.introductoryOffer?.isActive
                    ? "30px 15px 15px"
                    : "15px",
                  height: "calc(100vh - 180px)",
                  overflow: "auto",
                }}
              >
                <Typography
                  sx={{
                    fontSize: {
                      xs: "14px",
                      sm: "15px",
                      md: "15px",
                      lg: "15px",
                      xl: "16px",
                    },
                    fontWeight: 400,
                    lineHeight: {
                      xs: "21px",
                      sm: "24px",
                    },
                    color: "#000000B2",
                    textAlign: "left",
                    marginBottom: "17px",
                  }}
                >
                  Elevate your presence to new heights with our Premium Plan!
                  Crafted for aviation organizations ready to make a significant
                  impact, this plan offers unparalleled opportunities to engage
                  with a dynamic community of aviation professionals and rising
                  talent. This is your go-to tool for taking your brand
                  visibility and industry influence to the next level!
                  <br />
                  <Typography
                    sx={{
                      color: "#2A4876",
                      marginTop: "10px",
                      fontWeight: "600",
                      fontSize: "18px",
                    }}
                  >
                    One Year, Unlimited Potential: Our premium plan helps your
                    organization strengthen its position and impact across the
                    aviation industry.
                  </Typography>
                </Typography>

                <Typography
                  sx={{
                    color: "#2A4876",
                    fontWeight: "bold",
                    textAlign: "left",
                    fontSize: "15px",
                  }}
                >
                  Showcase Your Brand
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    marginTop: "5px",
                    gap: "5px",
                    marginBottom: "20px",
                  }}
                >
                  <img
                    src={greenTick}
                    alt="Green Tick"
                    style={{ width: "24px", height: "24px" }}
                  />
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "13px",
                      },
                      fontWeight: 400,
                      color: "#152134",
                      textAlign: "left",
                    }}
                  >
                    Elevate your presence and make a lasting impression with
                    Echo’s community of both aspiring and established aviation
                    professionals.
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    color: "#2A4876",
                    fontWeight: "bold",
                    textAlign: "left",
                    fontSize: "15px",
                  }}
                >
                  Unlimited Webinars and Virtual Events
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    marginTop: "5px",
                    gap: "5px",
                    marginBottom: "20px",
                  }}
                >
                  <img
                    src={greenTick}
                    alt="Green Tick"
                    style={{ width: "24px", height: "24px" }}
                  />
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "13px",
                      },
                      fontWeight: 400,
                      color: "#152134",
                      textAlign: "left",
                    }}
                  >
                    Host as many as you like and connect with your audience
                    year-round.
                  </Typography>
                </Box>
                {console.log(packToShow?.name)}

                <Typography
                  sx={{
                    color: "#2A4876",
                    fontWeight: "bold",
                    textAlign: "left",
                    fontSize: "15px",
                  }}
                >
                  Non-Stop Engagement
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    marginTop: "5px",
                    gap: "5px",
                    marginBottom: "20px",
                  }}
                >
                  <img
                    src={greenTick}
                    alt="Green Tick"
                    style={{ width: "24px", height: "24px" }}
                  />
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "13px",
                      },
                      fontWeight: 400,
                      color: "#152134",
                      textAlign: "left",
                    }}
                  >
                    Continuously share insights and spark conversations within
                    Echo’s vibrant community.
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    color: "#2A4876",
                    fontWeight: "bold",
                    textAlign: "left",
                    fontSize: "15px",
                  }}
                >
                  Unlimited Videos and Presentations
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    marginTop: "5px",
                    gap: "5px",
                    marginBottom: "20px",
                  }}
                >
                  <img
                    src={greenTick}
                    alt="Green Tick"
                    style={{ width: "24px", height: "24px" }}
                  />
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "13px",
                      },
                      fontWeight: 400,
                      color: "#152134",
                      textAlign: "left",
                    }}
                  >
                    Keep the spotlight on your expertise and company values,
                    share as much content as you&apos;d like.
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    color: "#2A4876",
                    fontWeight: "bold",
                    textAlign: "left",
                    fontSize: "15px",
                  }}
                >
                  Unlimited Articles and Blogs
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    marginTop: "5px",
                    gap: "5px",
                    marginBottom: "20px",
                  }}
                >
                  <img
                    src={greenTick}
                    alt="Green Tick"
                    style={{ width: "24px", height: "24px" }}
                  />
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "13px",
                      },
                      fontWeight: 400,
                      color: "#152134",
                      textAlign: "left",
                    }}
                  >
                    Share compelling articles that highlight your organization’s
                    unique appeal and achievements. Provide thought-provoking
                    content to position yourself as a leader in the aviation
                    industry.
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    color: "#2A4876",
                    fontWeight: "bold",
                    textAlign: "left",
                    fontSize: "15px",
                  }}
                >
                  Choose the payment option best suited to you:
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    marginTop: "10px",
                    gap: "10px",
                  }}
                >
                  <img
                    src={flightIcon}
                    alt=""
                    style={{
                      width: "21px",
                      height: "21px",
                    }}
                  />
                  <Typography>
                    <span style={{ fontWeight: "bold" }}>
                      ${packToShow?.prices[0]?.unit_amount / 100}/month with a
                      one-year commitment
                    </span>{" "}
                    for ultimate flexibility.
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    marginTop: "10px",
                    gap: "10px",
                    marginBottom: "20px",
                  }}
                >
                  <img
                    src={flightIcon}
                    alt=""
                    style={{
                      width: "21px",
                      height: "21px",
                    }}
                  />
                  <Typography>
                    <span style={{ fontWeight: "bold" }}>
                      ${packToShow?.prices[1]?.unit_amount / 100}/year
                    </span>{" "}
                    for long term growth and savings.
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    textAlign: "left",
                    color: "#000000B2",
                    fontStyle: "italic",
                    fontSize: "14px",
                  }}
                >
                  This is a one year plan with an option to make monthly
                  payments for a total of 12 months or pay a full annual price
                  that includes one free month.
                </Typography>
                <hr />
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: "10px",
                    fontWeight: "bold",
                  }}
                >
                  Note:
                </Typography>
                <Typography
                  sx={{
                    textAlign: "left",
                    color: "#000000B2",
                    fontStyle: "italic",
                    fontSize: "14px",
                  }}
                >
                  This offer extends the time your content is displayed,but it
                  does not allow for new content to be posted{" "}
                  <b>beyond your subscription period.</b>Content posting is only
                  available during the active subscription.
                </Typography>
              </Box>
            </Box>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default YearlyPremiumModal;
